// Mock data for Categories module

export const categoriesData = [
  {
    id: "CAT-145876",
    name: "Category Name1",
    productCount: 25,
    description: "Description Goes Here As",
    tags: ["Low Sodium"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "23 Jun, 2022",
    vendor: "Vendor A",
    vendorId: "VEN-145876"
  },
  {
    id: "CAT-145877",
    name: "Category ABC",
    productCount: 14,
    description: "Description Goes Here As",
    tags: ["PH Level +", "High Sodium"],
    status: "In Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "22 Jun, 2022",
    vendor: "Vendor B",
    vendorId: "VEN-145877"
  },
  {
    id: "CAT-145878",
    name: "Category Name1",
    productCount: 25,
    description: "Description Goes Here As",
    tags: ["PH Level +", "High Sodium"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "21 Jun, 2022",
    vendor: "Vendor C",
    vendorId: "VEN-145878"
  },
  {
    id: "CAT-145879",
    name: "Category Zy",
    productCount: 54,
    description: "Description Goes Here As",
    tags: [],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "20 Jun, 2022",
    vendor: "Vendor D",
    vendorId: "VEN-145879"
  },
  {
    id: "CAT-145880",
    name: "Category ABC",
    productCount: 25,
    description: "Description Goes Here As",
    tags: ["PH High"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "19 Jun, 2022",
    vendor: "Vendor E",
    vendorId: "VEN-145880"
  },
  {
    id: "CAT-145881",
    name: "Category Name1",
    productCount: 14,
    description: "Description Goes Here As",
    tags: ["PH Level +", "High Sodium"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "18 Jun, 2022",
    vendor: "Vendor F",
    vendorId: "VEN-145881"
  },
  {
    id: "CAT-145882",
    name: "Category Zy",
    productCount: 54,
    description: "Description Goes Here As",
    tags: ["High Sodium"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "17 Jun, 2022",
    vendor: "Vendor G",
    vendorId: "VEN-145882"
  },
  {
    id: "CAT-145883",
    name: "Fresh Fruits",
    productCount: 32,
    description: "Fresh seasonal fruits",
    tags: ["Organic", "Fresh"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "16 Jun, 2022",
    vendor: "Vendor H",
    vendorId: "VEN-145883"
  },
  {
    id: "CAT-145884",
    name: "Vegetables",
    productCount: 28,
    description: "Farm fresh vegetables",
    tags: ["Organic", "Healthy"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "15 Jun, 2022",
    vendor: "Vendor I",
    vendorId: "VEN-145884"
  },
  {
    id: "CAT-145885",
    name: "Dairy Products",
    productCount: 18,
    description: "Fresh dairy items",
    tags: ["Fresh", "Dairy"],
    status: "In Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "14 Jun, 2022",
    vendor: "Vendor J",
    vendorId: "VEN-145885"
  },
  {
    id: "CAT-145886",
    name: "Bakery",
    productCount: 45,
    description: "Fresh baked goods",
    tags: ["Baked", "Fresh"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "13 Jun, 2022",
    vendor: "Vendor K",
    vendorId: "VEN-145886"
  },
  {
    id: "CAT-145887",
    name: "Beverages",
    productCount: 67,
    description: "Drinks and beverages",
    tags: ["Drinks", "Cold"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "12 Jun, 2022",
    vendor: "Vendor L",
    vendorId: "VEN-145887"
  },
  {
    id: "CAT-145888",
    name: "Snacks",
    productCount: 89,
    description: "Crispy snacks and chips",
    tags: ["Snacks", "Crispy"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "11 Jun, 2022",
    vendor: "Vendor M",
    vendorId: "VEN-145888"
  },
  {
    id: "CAT-145889",
    name: "Frozen Foods",
    productCount: 34,
    description: "Frozen meals and items",
    tags: ["Frozen", "Ready"],
    status: "In Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "10 Jun, 2022",
    vendor: "Vendor N",
    vendorId: "VEN-145889"
  },
  {
    id: "CAT-145890",
    name: "Meat & Seafood",
    productCount: 41,
    description: "Fresh meat and seafood",
    tags: ["Fresh", "Protein"],
    status: "Active",
    icon: "https://via.placeholder.com/40",
    image: "https://via.placeholder.com/200",
    createdAt: "09 Jun, 2022",
    vendor: "Vendor O",
    vendorId: "VEN-145890"
  }
]

export const categoryStats = {
  totalCategories: 20,
  activeCategories: 8,
  inactiveCategories: 12,
  pendingRequests: 5
}
